import React from 'react';
export const LemanaProLogoMiniIcon = () => (/*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8435 4.63394L12.7126 9.1425L15.5452 11.9408V16.316H9.47256L8.45367 20.9994H21V9.73248L15.8435 4.63394Z",
  fill: "var(--logo-right-form-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9994 8.43492L15.8434 4.63394L12.7114 9.13901L11.9994 8.43492Z",
  fill: "var(--logo-angles-form-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.45367 16.315V20.9984L9.47281 16.315H8.45367Z",
  fill: "var(--logo-angles-form-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0007 0.832489L3 9.732V20.9988H8.45501V16.3154V11.9402L12.0007 8.43429L15.8447 4.63347L12.0007 0.832489Z",
  fill: "var(--logo-left-form-color)"
})));